import { render, staticRenderFns } from "./FanPortrait.vue?vue&type=template&id=18b3389c&scoped=true"
import script from "./FanPortrait.vue?vue&type=script&lang=js"
export * from "./FanPortrait.vue?vue&type=script&lang=js"
import style0 from "./FanPortrait.vue?vue&type=style&index=0&id=18b3389c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b3389c",
  null
  
)

export default component.exports